export const COOKIE_NAME = 'domstol_cookie';
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 90; // 90 dager

export const getCookieConsent = (): { remove_monsido_cookie?: boolean } => {
    try {
        const cookie = document.cookie.split('; ').find((row) => row.startsWith(`${COOKIE_NAME}=`));
        return cookie ? JSON.parse(decodeURIComponent(cookie.split('=')[1])) : {};
    } catch {
        return {};
    }
};

export const setConsentCookie = (removeMonsido: boolean) => {
    const value = encodeURIComponent(JSON.stringify({ remove_monsido_cookie: removeMonsido }));
    document.cookie = `${COOKIE_NAME}=${value}; path=/; max-age=${COOKIE_MAX_AGE}`;
};
